export function logDebug(...args: any[]) {
    var ALLOWED_DOMAINS = [
        'localhost',
        '127.0.0.1',
        '',
        '::1',
        'reelflow.test',
        'reelflow-api.test',
    ];

    // @ts-expect-error
    var isDebug = window.__REELFLOW_DEBUG;
    var isLocalhost =
        window.location &&
        window.location.hostname &&
        ALLOWED_DOMAINS.includes(window.location.hostname);

    if (isLocalhost || isDebug) {
        console.log(...args);
    }
}
